import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/home/logo.png'
import _imports_1 from '@/assets/nav/xx.png'
import _imports_2 from '@/assets/nav/xs.png'
import _imports_3 from '@/assets/home/x.png'
import _imports_4 from '@/assets/nav/close.png'
import _imports_5 from '@/assets/nav/more.png'
import _imports_6 from '@/assets/nav/t.png'
import _imports_7 from '@/assets/nav/d.png'
import _imports_8 from '@/assets/nav/i.png'
import _imports_9 from '@/assets/home/tg.png'


const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "nav-left" }
const _hoisted_3 = { class: "tab" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "tab-item-txt" }
const _hoisted_6 = {
  key: 0,
  src: _imports_1,
  alt: "",
  class: "bottom-icon"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_2,
  alt: "",
  class: "bottom-icon"
}
const _hoisted_8 = {
  key: 0,
  class: "coming-soon"
}
const _hoisted_9 = {
  key: 1,
  class: "menu-tip"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "nav-right" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "dropdown-content" }
const _hoisted_15 = { class: "mobile-nav" }
const _hoisted_16 = { class: "mobile-right" }
const _hoisted_17 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_18 = { class: "dropdown-content" }
const _hoisted_19 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_20 = { class: "dropdown-content" }
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = { class: "right-icon" }
const _hoisted_23 = { class: "tab" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "item-txt" }
const _hoisted_26 = { class: "tab-item-txt" }
const _hoisted_27 = {
  key: 0,
  src: _imports_1,
  alt: "",
  class: "bottom-icon"
}
const _hoisted_28 = {
  key: 1,
  src: _imports_2,
  alt: "",
  class: "bottom-icon"
}
const _hoisted_29 = {
  key: 0,
  class: "coming-soon"
}
const _hoisted_30 = {
  key: 1,
  class: "menu-tip"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "menu-footer" }

import { useAccount, useSignMessage } from "@wagmi/vue";
import { useAppKit } from "@reown/appkit/vue";
// import { signsMessage } from "@/utils/config";
import { watch, ref } from "vue";
import "./Header.scss";
import { authApi } from "@/api/sign";
import { useRouter } from "vue-router"; // 添加 router 导入
import { setLocale, type SupportedLocales } from "@/locales";
import {
  faqUrlApi,
  xUrlApi,
  tgUrlApi,
  insUrlApi,
  disUrlApi,
} from "@/api/other";
import { useI18n } from "vue-i18n";

interface TabItem {
  label: string;
  url?: string;
  visible?: boolean;
  child?: TabItem[];
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: "Header",
},
  __name: 'Header',
  setup(__props) {

const { open, close } = useAppKit();
const { address } = useAccount();
const { signMessageAsync } = useSignMessage();
const { getSignMsg, setSignApi } = authApi;
const router = useRouter(); // 使用 router
const { t, locale } = useI18n();



const tabList = ref<TabItem[]>([
  { label: "nav.menu.extinct", url: "/" },
  {
    label: "nav.menu.iceAge",
    url: "/child",
    visible: false,
    child: [
      { label: "nav.menu.iceAge", url: "/child" },
      { label: "nav.menu.purchase", url: "/market" },
      // { label: "nav.menu.purchase", url: "/market" },
    ],
  },
  // { label: "nav.menu.cretaceous", url: "" },
  { label: "nav.menu.market", url: "" },
  { label: "nav.menu.nftGame", url: "" },
  { label: "nav.menu.museum", url: "" },
  { label: "nav.menu.irlEvents", url: "" },
  {
    label: "nav.menu.more",
    url: "/notice",
    visible: false,
    child: [
      { label: "nav.menu.announcement", url: "/notice" },
      { label: "nav.menu.whitepaper", url: "/purchase" },
      { label: "FAQ", url: "FAQ" },
    ],
  },
]);
const tabIndex = ref(0);
const isShow = ref(false);
const select = ref(false);
const selectBg = ref(false);
const isConnecting = ref(false);
const tabChildUrl = ref("");
const tabChildIndex = ref(0);

// 格式化地址
const formatAddress = (address: string) => {
  return `${address.slice(0, 4)}...${address.slice(-4)}`;
};

// 获取签名
const getSign = async (address: string) => {
  const signRes = await getSignMsg({ address });
  console.log("signRes:", signRes);
  return signRes;
};

const goPathUrl = async (type: string) => {
  // 社交媒体跳转
  let api;
  switch (type) {
    case "tg":
      api = tgUrlApi;
      break;
    case "dis":
      api = disUrlApi;
      break;
    case "ins":
      api = insUrlApi;
      break;
    case "x":
      api = xUrlApi;
      break;
  }

  if (api) {
    try {
      const res = await api();
      if (res.code === 200 && res.data) {
        window.location.href = res.data as string;
      }
    } catch (error) {
      console.error(`Failed to fetch ${type} URL:`, error);
    }
  }
};
const toggleLanguage = () => {
  select.value = !select.value;
  selectBg.value = !selectBg.value;
};

const toggleLanguageCk = (lang: string) => {
  const locale = lang === "zh" ? "zh-cn" : "en-us";
  setLocale(locale as SupportedLocales);
  select.value = false;
  selectBg.value = false;
};
const tabCk = (index: number, item: any) => {
  if (item.child) {
    item.visible = !item.visible;

    // if (index !== this.tabIndex) {
    //   item.visible = false;
    //   console.log("aaaa");
    // }
    tabIndex.value = index;
    tabList.value.forEach((items, indexs) => {
      if (items.child && indexs !== index) {
        items.visible = false;
      }
    });
  } else {
    if (tabIndex.value === index || !item.url) return;
    tabIndex.value = index;
    router.push({ path: item.url, query: {} });
    isShow.value = false;
    tabList.value.forEach((item) => {
      item.visible = false;
    });
  }
};
const childCk = (childIndex: number, item: any, index: number) => {
  tabIndex.value = index;
  console.log(item.url);
  if (item.url === "FAQ") {
    console.log("FAQ");
    faqUrlApi().then((res: any) => {
      // 添加类型注解
      if (res.code === 200) {
        window.location.href = res.data;
      }
    });
  } else {
    if (tabChildUrl.value === item.url || !item.url) return;
    tabChildIndex.value = childIndex;
    tabChildUrl.value = item.url;
    router.push({ path: item.url, query: {} });
    isShow.value = false;
  }
};
// watch(
//   address,
//   async (newValue, oldValue) => {
//     // 这里可以添加你想要的处理逻辑
//     if (newValue) {
//       const data = await getSign(newValue);
//       if (data.code === 200) {
//         const signature = await signMessageAsync({ message: data.data.msg });
//         const signTxt = await setSignApi({
//           msg: data.data.msg,
//           sign: signature,
//         });
//         console.log("signTxt----:", signTxt);
//       }
//       console.log("data----:", data.data.msg);
//     } else {
//       console.log("钱包未连接");
//     }
//   },
//   { deep: true }
// ); // 使用 deep: true 来深度监听对象的变化
// 监听 address 变化
watch(address, async (newValue, oldValue) => {
  // 如果新旧值相同，则不执行
  if (newValue === oldValue || !newValue) {
    return;
  }

  const data = await getSign(newValue);
  if (data.code === 200) {
    const signature = await signMessageAsync({ message: data.data.msg });
    const signTxt = await setSignApi({
      msg: data.data.msg,
      sign: signature,
    });
    console.log("signTxt----:", signTxt);
  }
  console.log("data----:", data.data.msg);
}); // 移除 deep: true，因为我们只需要监听 address 的值变化

const handleConnectWallet = () => {
  if (address) {
    open();
  } else {
    close();
  }
};
// 监听路由变化
watch(
  () => router.currentRoute.value.path,
  (newPath) => {
    initActiveTab();
  }
);
// 添加初始化高亮的函数
const initActiveTab = () => {
  const currentPath = router.currentRoute.value.path;

  // 遍历查找匹配的路由
  tabList.value.forEach((item, index) => {
    if (item.url === currentPath) {
      tabIndex.value = index;
      return;
    }

    // 检查子菜单
    if (item.child) {
      const childIndex = item.child.findIndex(
        (child) => child.url === currentPath
      );
      if (childIndex !== -1) {
        tabIndex.value = index;
        tabChildIndex.value = childIndex;
        tabChildUrl.value = currentPath;
      }
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[14] || (_cache[14] = _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          class: "logo-icon"
        }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["tab-item", { active: tabIndex.value === index }]),
              key: index,
              onClick: ($event: any) => (tabCk(index, item))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(_unref(t)(item.label)) + " ", 1),
                (item.child)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!item.visible)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                        : (_openBlock(), _createElementBlock("img", _hoisted_7))
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (!item.url)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)("home.comingSoon")), 1))
                : _createCommentVNode("", true),
              (item.child && item.visible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.child, (childItem, childIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: childIndex,
                        class: _normalizeClass(["menu-tip-item", {
                    'border-none': childIndex === item.child.length - 1,
                  }]),
                        onClick: ($event: any) => (childCk(childIndex, childItem, index))
                      }, _toDisplayString(_unref(t)(childItem.label)), 11, _hoisted_10))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_4))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: _normalizeClass(["nav-btn margin-right-15 w-131 left-btn", { connecting: isConnecting.value }]),
          onClick: handleConnectWallet
        }, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(address) && _unref(address)
                ? formatAddress(_unref(address))
                : _unref(t)("nav.connectWallet")), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["nav-btn", { 'switch-language': selectBg.value }]),
          onClick: toggleLanguage
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createTextVNode(_toDisplayString(_unref(t)("nav.switchLanguage")) + " ", 1),
            _cache[15] || (_cache[15] = _createElementVNode("img", {
              src: _imports_3,
              alt: "",
              class: "x-icon"
            }, null, -1))
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toggleLanguageCk('zh')), ["stop"]))
            }, "繁体中文"),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (toggleLanguageCk('en')), ["stop"]))
            }, "English")
          ], 512), [
            [_vShow, select.value]
          ])
        ], 2)
      ])
    ]),
    (isShow.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mobile-nav-box",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (isShow.value = false))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      _cache[18] || (_cache[18] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "logo-icon"
      }, null, -1)),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("div", {
          class: "switch",
          onClick: toggleLanguage
        }, [
          _createElementVNode("div", _hoisted_17, [
            _createTextVNode(_toDisplayString(_unref(t)("nav.switchLanguage")) + " ", 1),
            _cache[16] || (_cache[16] = _createElementVNode("img", {
              src: _imports_3,
              alt: "",
              class: "x-icon"
            }, null, -1))
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (toggleLanguageCk('zh')), ["stop"]))
            }, "繁体中文"),
            _createElementVNode("div", {
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (toggleLanguageCk('en')), ["stop"]))
            }, "English")
          ], 512), [
            [_vShow, select.value]
          ])
        ], 512), [
          [_vShow, !selectBg.value]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "switch-language-mobile",
          onClick: toggleLanguage
        }, [
          _createElementVNode("div", _hoisted_19, [
            _createTextVNode(_toDisplayString(_unref(t)("nav.switchLanguage")) + " ", 1),
            _cache[17] || (_cache[17] = _createElementVNode("img", {
              src: _imports_3,
              alt: "",
              class: "x-icon"
            }, null, -1))
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", {
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (toggleLanguageCk('zh')), ["stop"]))
            }, "繁体中文"),
            _createElementVNode("div", {
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (toggleLanguageCk('en')), ["stop"]))
            }, "English")
          ], 512), [
            [_vShow, select.value]
          ])
        ], 512), [
          [_vShow, selectBg.value]
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["nav-btn margin-right-15 w-131 left-btn", { connecting: isConnecting.value }]),
          onClick: handleConnectWallet
        }, [
          _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(address) && _unref(address)
                ? formatAddress(_unref(address))
                : _unref(t)("nav.connectWallet")), 1)
        ], 2),
        _createElementVNode("div", _hoisted_22, [
          (isShow.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _imports_4,
                alt: "",
                class: "close-icon",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (isShow.value = false))
              }))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _imports_5,
                alt: "",
                class: "more-icon",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (isShow.value = true))
              }))
        ])
      ])
    ]),
    (isShow.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "mobile-menu",
          onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["tab-item", { active: tabIndex.value === index }]),
                key: index,
                onClick: ($event: any) => (tabCk(index, item))
              }, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createTextVNode(_toDisplayString(_unref(t)(item.label)) + " ", 1),
                    (item.child)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (!item.visible)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_27))
                            : (_openBlock(), _createElementBlock("img", _hoisted_28))
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  (!item.url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(t)("home.comingSoon")), 1))
                    : _createCommentVNode("", true),
                  (item.child && item.visible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.child, (childItem, childIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: childIndex,
                            class: _normalizeClass(["menu-tip-item", {
                    'border-none': childIndex === item.child.length - 1,
                  }]),
                            onClick: ($event: any) => (childCk(childIndex, childItem, index))
                          }, _toDisplayString(_unref(t)(childItem.label)), 11, _hoisted_31))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_24))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("img", {
              src: _imports_6,
              alt: "",
              class: "f-icon",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (goPathUrl('x')))
            }),
            _createElementVNode("img", {
              src: _imports_7,
              alt: "",
              class: "f-icon margin-left",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (goPathUrl('dis')))
            }),
            _createElementVNode("img", {
              src: _imports_8,
              alt: "",
              class: "f-icon",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (goPathUrl('ins')))
            }),
            _createElementVNode("img", {
              src: _imports_9,
              alt: "",
              class: "f-icon margin-left-two",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (goPathUrl('tg')))
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})